import { Action } from '@ngrx/store'
import { AddCartEvent, ApiOrder, DeleteCartLineEvent } from '../models/cart-models';

export const GET = '[Cart] Get'
export const GET_SUCCESS = '[Cart] Get Success'
export const GET_FAILED = '[Cart] Get Failed'

export const ADD = '[Cart] Add'
export const ADD_SUCCESS = '[Cart] Add Successfull'
export const ADD_FAILED = '[Cart] Add Failed'

export const REMOVE = '[Cart] Remove'
export const REMOVE_SUCCESS = '[Cart] Remove Success'
export const REMOVE_FAILED = '[Cart] Remove Failed'

export const CHANGE = '[Cart] Change'
export const CHANGE_SUCCESS = '[Cart] Change Success'
export const CHANGE_FAILED = '[Cart] Change Failed'

export const RESET = '[Cart] Reset'

export class Get implements Action {
    readonly type = GET
    constructor(public includeExtraCosts: boolean = false) {}
}
export class GetSuccess implements Action {
    readonly type = GET_SUCCESS
    constructor(public payload: ApiOrder) {}
}
export class GetFailed implements Action {
    readonly type = GET_FAILED
    constructor(public payload: any) {}
}

export class Add implements Action {
    readonly type = ADD
    constructor(public payload: AddCartEvent) {}
}
export class AddSuccess implements Action {
    readonly type = ADD_SUCCESS
    constructor(public payload: ApiOrder) {}
}
export class AddFailed implements Action {
    readonly type = ADD_FAILED
    constructor(public payload: any) {}
}

export class Remove implements Action {
    readonly type = REMOVE
    constructor(public payload: DeleteCartLineEvent) {}
}
export class RemoveSuccess implements Action {
    readonly type = REMOVE_SUCCESS
    constructor(public payload: ApiOrder) {}
}
export class RemoveFailed implements Action {
    readonly type = REMOVE_FAILED
    constructor(public payload: any) {}
}

export class Change implements Action {
    readonly type = CHANGE
    constructor(public payload: AddCartEvent) {}
}
export class ChangeSuccess implements Action {
    readonly type = CHANGE_SUCCESS
    constructor(public payload: ApiOrder) {}
}
export class ChangeFailed implements Action {
    readonly type = CHANGE_FAILED
    constructor(public payload: any) {}
}

export class Reset implements Action {
    readonly type = RESET
}

export type Actions =
    Add
    | AddSuccess
    | AddFailed
    | Get
    | GetSuccess
    | GetFailed
    | Remove
    | RemoveSuccess
    | RemoveFailed
    | Change
    | ChangeSuccess
    | ChangeFailed
    | Reset
